import Vue from "vue";
import "element-ui/lib/theme-chalk/index.css"; //引入element-plus样式

import {
  CheckboxGroup,
  Checkbox,
  Collapse,
  CollapseItem,
  Empty,
  Form,
  FormItem,
  Table,
  TableColumn,
  Radio,
  RadioGroup,
  Input,
  Button,
  Select,
  DatePicker,
  TimePicker,
  Row,
  Col,
  Card,
  Tag,
  Rate,
  Option,
  Alert,
  Dialog,
  Pagination,
  Tree,
  Switch,
  Steps,
  Step,
  InputNumber,
  Tooltip,
  Transfer,
  Popover,
  Badge,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Loading,
  Scrollbar,
  Menu,
  Submenu,
  MenuItem,
  Breadcrumb,
  BreadcrumbItem,
  Upload,
  Image,
  Tabs,
  TabPane,
  Popconfirm,
  Drawer,
  Link,
  Cascader,
} from "element-ui";
Vue.use(CheckboxGroup);
Vue.use(Checkbox);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Empty);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Input);
Vue.use(Button);
Vue.use(Select);
Vue.use(DatePicker);
Vue.use(TimePicker);
Vue.use(Row);
Vue.use(Col);
Vue.use(Card);
Vue.use(Tag);
Vue.use(Rate);
Vue.use(Option);
Vue.use(Alert);
Vue.use(Dialog);
Vue.use(Pagination);
Vue.use(Tree);
Vue.use(Switch);
Vue.use(Steps);
Vue.use(Step);
Vue.use(InputNumber);
Vue.use(Tooltip);
Vue.use(Transfer);
Vue.use(Popover);
Vue.use(Badge);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Scrollbar);
Vue.use(Menu);
Vue.use(Submenu);
Vue.use(MenuItem);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Upload);
Vue.use(Image);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Popconfirm);
Vue.use(Drawer);
Vue.use(Link);
Vue.use(Cascader);
Vue.use(Loading.directive);
